import {Component, Inject, OnInit} from '@angular/core';
import {Broadcast} from "../../model/broadcast/broadcast";
import {BroadcastsService} from "../../services/broadcasts.service";
import {UntypedFormControl, UntypedFormGroup, Validators, ReactiveFormsModule} from "@angular/forms";
import "firebase/compat/firestore";
import {Player} from "../../model/broadcast/player";
import {UtilService} from "../../services/util.service";
import {MAT_DIALOG_DATA, MatDialogRef, MatDialogModule} from "@angular/material/dialog";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {MatTabsModule} from "@angular/material/tabs";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatCardModule} from "@angular/material/card";
import {MatRadioModule} from "@angular/material/radio";
import {MatIconModule} from "@angular/material/icon";
import {NgxColorsModule} from "ngx-colors";

@Component({
    selector: 'app-config-dialog',
    templateUrl: './config-dialog.component.html',
    styleUrls: ['./config-dialog.component.scss'],
    standalone: true,
    imports: [
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatTabsModule,
        MatCheckboxModule,
        MatCardModule,
        MatRadioModule,
        MatIconModule,
        NgxColorsModule,
        ReactiveFormsModule
    ]
})
export class ConfigDialogComponent implements OnInit {

  formData: UntypedFormGroup;

  colorPalette: Array<any> = [
    '#020202',
    '#0d0e28',
    '#041c2c',
    '#041e42',
    '#142c48',
    '#183883',
    '#193c90',
    '#214997',
    '#03483a',
    '#b31e2a',
    '#D50032',
    '#f48117',
    '#dddd00',
    '#ffffff',
  ];

  private SAMPLE_BATTER: Player = {
    name: "Current batter", hrDerby: 0, guid: '', batting: true
  };

  constructor(
    public dialogRef: MatDialogRef<ConfigDialogComponent>,
    public broadcastsService: BroadcastsService,
    public utilService: UtilService,
    @Inject(MAT_DIALOG_DATA) public broadcast: Broadcast,
  ) {
  }

  ngOnInit(): void {
    this.formData = new UntypedFormGroup({
      statusMsg: new UntypedFormControl(this.broadcast.config.statusMsg),
      bigLogoUrl: new UntypedFormControl(this.broadcast.config.bigLogoUrl),
      smallLogoUrl: new UntypedFormControl(this.broadcast.config.smallLogoUrl),
      backgroundColor: new UntypedFormControl(this.broadcast.config.backgroundColor),
      autopilot: new UntypedFormControl(this.broadcast.config.autopilot),
      skipPortraits: new UntypedFormControl(this.broadcast.config.skipPortraits),
      manualStatus: new UntypedFormControl(this.broadcast.config.manualStatus),
      useManualLineups: new UntypedFormControl(this.broadcast.config.useManualLineups),
      unites: new UntypedFormControl(this.broadcast.config.unites),
      lowerRange: new UntypedFormControl(this.broadcast.config.lowerRange),
      boxScoreTime: new UntypedFormControl(this.broadcast.config.boxScoreTime),
      batterTime: new UntypedFormControl(this.broadcast.config.batterTime),
      awayConfig: new UntypedFormGroup({
        fullName: new UntypedFormControl(this.broadcast.config.awayConfig.fullName, [Validators.required]),
        primaryColor: new UntypedFormControl(this.broadcast.config.awayConfig.primaryColor, [Validators.required]),
        secondaryColor: new UntypedFormControl(this.broadcast.config.awayConfig.secondaryColor),
        logoUrl: new UntypedFormControl(this.broadcast.config.awayConfig.logoUrl),
      }),
      homeConfig: new UntypedFormGroup({
        fullName: new UntypedFormControl(this.broadcast.config.homeConfig.fullName, [Validators.required]),
        primaryColor: new UntypedFormControl(this.broadcast.config.homeConfig.primaryColor, [Validators.required]),
        secondaryColor: new UntypedFormControl(this.broadcast.config.homeConfig.secondaryColor),
        logoUrl: new UntypedFormControl(this.broadcast.config.homeConfig.logoUrl),
      }),
    });
    if (!this.broadcast.leagueId) {
      this.formData.controls.autopilot.disable();
    }
  }

  close(): void {
    this.dialogRef.close(this.broadcast.config);
  }

  update(): void {
    const old = this.broadcast.config;
    this.broadcast.config = this.formData.value;
    this.broadcast.config.homeConfig.id = old.homeConfig.id;
    this.broadcast.config.homeConfig.shortName = old.homeConfig.shortName;
    this.broadcast.config.awayConfig.id = old.awayConfig.id;
    this.broadcast.config.awayConfig.shortName = old.awayConfig.shortName;
    this.broadcastsService.updateConfig(this.broadcast).then(() => {
      this.dialogRef.close('update');
    });
  }

  getFirstLetter(shortName: string): string {
    return shortName[0];
  }

  get awayColor(): UntypedFormControl {
    return this.formData.controls.awayColor as UntypedFormControl;
  }

  get homeColor(): UntypedFormControl {
    return this.formData.controls.homeColor as UntypedFormControl;
  }

  get awayLogoUrl(): UntypedFormControl {
    return this.formData.controls.awayLogoUrl as UntypedFormControl;
  }

  get homeLogoUrl(): UntypedFormControl {
    return this.formData.controls.homeLogoUrl as UntypedFormControl;
  }

  get statusMsg(): UntypedFormControl {
    return this.formData.controls.statusMsg as UntypedFormControl;
  }
}
